/**
 * Fisher-Yates shuffle for arrays.
 * Shared utility used by LoadingMessages, template gallery, and placeholder rotation.
 */
export function shuffleArray<T>(items: T[]): T[] {
	const copy = [...items];
	for (let i = copy.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[copy[i], copy[j]] = [copy[j], copy[i]];
	}
	return copy;
}
